export const standardTransition = { duration: 0.14, ease: [0.2, 0, 0, 1] } as const;
export const iconTransition = { duration: 0.12, ease: [0.2, 0, 0, 1] } as const;
export const instantTransition = { duration: 0 } as const;
